import { LexicalEditor, CLEAR_EDITOR_COMMAND } from 'lexical';

export const clearEditor = (editor: LexicalEditor): void => {
  editor.dispatchCommand(CLEAR_EDITOR_COMMAND, undefined);
};
